import React, { Component } from 'react';
import { Modal, Steps, Button, message } from 'antd';
const Step = Steps.Step;

class TruckModal extends Component {
  constructor(props) {
    super(props);
    this.state = {step: 0, stepLimit: 0, validation: false, truck: {}};
    this.handleNext = this.handleNext.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.showStep = this.showStep.bind(this);
    // Input values
    this.handlePlates = this.handlePlates.bind(this);
    this.handleReference = this.handleReference.bind(this);
    this.setProp = this.setProp.bind(this);
  }

  handleNext() {
    if(!this.state.validation)
      return message.warning('Necesitas llenar los campos obligatorios')

    if(this.state.step === this.state.stepLimit) {
      this.props.handleSave(this.state.truck);
      this.setState({validation: true, truck: {}});
    } else {
      this.setState({step: this.state.step + 1});
    }
  }

  handleBack() {
    if(this.state.step === 0) {
      this.props.handleClose();
    } else {
      this.setState({step: this.state.step - 1});
    }
  }

  handlePlates(event) {
    this.setProp('plates', event.target.value);
    this.setState({validation: true});
  }

  handleReference(event) {
    this.setProp('reference', event.target.value);
    this.setState({validation: true});
  }

  setProp(prop, value) {
    const record = this.state.truck;
    record[prop] = value;

    this.setState({truck: record});
  }

  showStep(step) {
    if(step === this.state.step) {
      return 'block';
    } else {
      return 'none';
    }
  }

  render() {
    // Render component
    return (
      <Modal
        title={this.props.title}
        visible={this.props.visible}
        onCancel={this.props.handleClose}
        width={800}
        footer={null}
        destroyOnClose={true}
      >
        <div className="row" style={{ padding: '0px 30px' }}>
          <Steps size="small" current={this.state.step}>
            <Step title="Placas" />
            <Step title="Finalizar" />
          </Steps>
        </div>

        <br/> <br/>

        <div className="row" style={{ padding: '0px 30px' }}>
          <div style={{ width: '100%', display: this.showStep(0) }}>
            <div className="form-group">
              <label>Placas</label>
              <input type="text" className="form-control" defaultValue={this.props.current.plates} placeholder="Placas del camión" onChange={this.handlePlates} />
            </div>

            <div className="form-group">
              <label>Referencia o detalles</label>
              <input type="text" className="form-control" defaultValue={this.props.current.reference} placeholder="Color, Marca, Propio" onChange={this.handleReference} />
            </div>
          </div>
        </div>

        <br/><hr/>

        <div className="form-group text-center">
          <Button type="dashed" style={{ marginRight: '10px' }} onClick={this.handleBack}>Atras</Button>
          <Button type="primary" onClick={this.handleNext}>Siguiente</Button>
        </div>
      </Modal>
    );
  }
}

export default TruckModal;



// WEBPACK FOOTER //
// ./src/components/modals/TruckModal.js